import i18n from "../i18n"

class User {
  setUser(user) {
    this.user = user
  }
  getUser() {
    return this.user
  }
}

const bid2WinUser = new User()

export function setUser(user) {
  bid2WinUser.setUser(user)
}

export function getUser() {
  return bid2WinUser.getUser()
}

export function secondsToHms(d) {
  d = Number(d)
  var h = Math.floor(d / 3600)
  var m = Math.floor((d % 3600) / 60)
  var s = Math.floor((d % 3600) % 60)

  var hDisplay = "00"
  var mDisplay = "00"
  var sDisplay = "00"

  if (h < 24) {
    if (h < 10) {
      hDisplay = h > 0 ? h : "00"
    } else {
      var hDisplay = h > 0 ? h : "00"
    }

    if (m < 10) {
      mDisplay = m > 0 ? "0" + m : "00"
    } else {
      mDisplay = m > 0 ? m : "00"
    }

    if (s < 10) {
      sDisplay = s > 0 ? "0" + s : "00"
    } else if (s > 0) {
      sDisplay = s > 0 ? s : "00"
    } else {
      sDisplay = "00"
    }

    return `${hDisplay} : ${mDisplay} : ${sDisplay}`
  }

  if (h > 24) {
    const day = Math.round(h / 24)
    const textDay =
      day > 1 ? `${day} ${i18n.t("Days")}` : `${day} ${i18n.t("Day")}`
    return textDay
  }
}



// WEBPACK FOOTER //
// ./src/util/Utility.js